import { render, staticRenderFns } from "./PositionCapacityAttachmentsBadge.vue?vue&type=template&id=20fe9c3e&scoped=true"
import script from "./PositionCapacityAttachmentsBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionCapacityAttachmentsBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionCapacityAttachmentsBadge.vue?vue&type=style&index=0&id=20fe9c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe9c3e",
  null
  
)

export default component.exports